import { memo } from 'react'

import s from './HeaderLogo.module.scss'
import Image from 'next/image'
import { getHeaderLogo } from './getHeaderLogo'

interface IHeaderLogoProps {
    isWhiteLogo: boolean
}

export const HeaderLogo = memo(({isWhiteLogo}: IHeaderLogoProps) => {
    return (
        <a
            style={{ zIndex: 51 }}
            href='/'
        >
            <div className='header__logo'>
                <Image
                    width={182}
                    height={38}
                    src={isWhiteLogo ? getHeaderLogo(false) : getHeaderLogo(true)}
                    alt='logo'
                />
            </div>
            <div className='header__logo-mobile'>
                <Image
                    width={162}
                    height={32}
                    src={isWhiteLogo ? getHeaderLogo(false) : getHeaderLogo(true)}
                    alt='logo-mobile'
                />
            </div>
        </a>
    )
})
